import {ConnectionUser, deleteConnection, useAppDispatch, withAsyncThunkErrorHandling} from '@lib/store';
import {useTranslation} from 'react-i18next';
import {Icon} from '@atoms';
import {Avatar, IconButton} from '@molecules';
import {useNavigate} from 'react-router-dom';
import {useDestructiveDialog} from '@hooks';

export const ConnectionSectionItem = ({user}: {user: ConnectionUser}) => {
  const {t} = useTranslation('connection');
  const {destructiveDialog} = useDestructiveDialog();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const deleteColleague = async () => {
    const confirmation = await destructiveDialog(t('DeleteConnectionTitle'), t('DeleteConnectionMessage'), 'warning');

    if (confirmation) {
      dispatch(withAsyncThunkErrorHandling(() => deleteConnection({userId: user.id, connectionId: user.connectionId})));
    }
  };

  return (
    <div
      onClick={() => {
        navigate(`/connect/connections/${user.id}`);
      }}
      className={`grid grid-cols-[auto_1fr_auto_auto] gap-x-4 items-center w-full px-4 sm:px-6 md:px-8 py-4 text-left hover:bg-mapiq-black-50 transition-colors cursor-pointer`}>
      <Avatar
        size="large"
        user={user}
        shouldShowCheckIn
        className="shadow-mapiq-small flex-shrink-0"
      />

      <div className="grid  ">
        <p className="font-semibold text-mapiq-black-800* truncate">{user.name}</p>

        <p className=" text-mapiq-black-500 truncate">{user.email}</p>
      </div>

      <IconButton
        aria-label={t('DeleteConnection')}
        data-testid="organisms-connectionsCardCell-deleteConnection-button"
        iconButton="tertiary"
        icon="trash"
        onClick={deleteColleague}
        size="xsmall"
      />

      <Icon
        icon="caretRight"
        className="ml-auto self-center size-5"
      />
    </div>
  );
};
